// Version: 1.0 - Main App Component for headacheMD ER
import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Disclaimer from './components/Disclaimer';
import About from './components/About';
import Services from './components/Services';
import WhenToVisit from './components/WhenToVisit';
import FindER from './components/FindER';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Disclaimer />
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <WhenToVisit />
        <FindER />
      </main>
      <Footer />
    </div>
  );
}

export default App;
